namespace app.support.dashboards {
    'use strict';

    angular
        .module('app.support.dashboards', ['app.support', 'oc.lazyLoad']);
}